"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import "../AutoVerkaufen.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "../sections/TopSection";
import { AutoVerkaufenGrid } from "../../../common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import höchstenPreis from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-verkauf.avif";
import vonZuhauseAus from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-hoechstpreis.avif";
import { fragenNotverkauf } from "../data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AutoNotVerkauf() {
  const [step, setStep] = useState(1);

  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title={<>Notverkauf deines Autos: Schnell, diskret, fair</>}
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung für deinen
            Notverkauf.
          </>
        }
        customNav="Auto verkaufen"
        customNavLink="/auto-verkaufen"
        linkname="Notverkauf Auto"
        link="/auto-verkaufen/notverkauf-auto"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen/notverkauf-auto"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color AV-below-fold">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Was ist ein Notverkauf für ein Auto?"
              leftText={
                <>
                  <p>Manchmal muss es einfach schnell gehen.</p>
                  <p>
                    Ein plötzlicher Jobwechsel, finanzielle Engpässe, ein
                    Motorschaden oder eine anstehende Auswanderung: es gibt
                    viele Gründe, warum ein Notverkauf des Autos privat nötig
                    wird. Wer sein Fahrzeug dringend verkaufen muss, hat oft
                    keine Zeit für langwierige Inserate, Preisverhandlungen oder
                    riskante Treffen mit fremden Käufern.
                  </p>
                  <p>Genau hier kommt Autoeinfachlos ins Spiel:</p>
                  <p>
                    Wir bieten dir die Möglichkeit, dein Auto schnell, sicher
                    und zum fairen Preis zu verkaufen: ohne Stress, ohne Risiko,
                    aber mit maximaler Transparenz.
                  </p>
                  <p>
                    Über unser Netzwerk mit mehr als 5.000 geprüften Händlern
                    findest du innerhalb von 24 Stunden einen passenden Käufer
                    und bekommst dein Geld sicher ausgezahlt.
                  </p>
                </>
              }
              rightFirstTitle="Wann ist ein Notverkauf des Autos sinnvoll?"
              rightFirstText={
                <>
                  <p>
                    Ein Notverkauf ist keine seltene Situation – und oft die
                    vernünftigste Entscheidung, um finanzielle oder
                    organisatorische Probleme schnell zu lösen. Typische Gründe
                    sind:
                  </p>

                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Finanzielle Engpässe:</strong> Wenn kurzfristig
                      Liquidität benötigt wird
                    </li>
                    <li>
                      <strong>Jobwechsel oder Auswanderung:</strong> Das
                      Fahrzeug wird am neuen Wohnort nicht mehr gebraucht
                    </li>
                    <li>
                      <strong>Reparaturkosten oder Motorschaden:</strong> Eine
                      Instandsetzung lohnt sich wirtschaftlich nicht
                    </li>
                    <li>
                      <strong>Erbschaft oder Trennung:</strong> Ein oder mehrere
                      Fahrzeuge müssen schnell abgegeben werden
                    </li>
                    <li>
                      <strong>Drohende Stilllegung oder Abmeldung:</strong> Das
                      Auto verursacht laufende Kosten, obwohl es nicht genutzt
                      wird
                    </li>
                  </ul>

                  <p>
                    Je früher du handelst, desto besser ist der erzielbare
                    Preis. Denn mit jedem Monat Stillstand verliert dein Auto an
                    Wert, durch ablaufende Versicherungen, steigende Standkosten
                    oder sinkende Nachfrage.
                  </p>
                  <p>
                    Ein schneller, geplanter Notverkauf hilft dir, diesen
                    Wertverlust zu stoppen und gleichzeitig finanzielle Freiheit
                    zu gewinnen.
                  </p>
                </>
              }
              rightSecondTitle="Auto privat verkaufen oder über Händlernetzwerk?"
              rightSecondText={
                <>
                  <p>
                    Wer einen Auto-Notverkauf plant, steht vor einer wichtigen
                    Entscheidung:
                    <br /> Soll das Fahrzeug privat verkauft werden oder ist der
                    Weg über ein professionelles Händlernetzwerk sinnvoller?
                  </p>

                  <p>
                    <strong>Privatverkauf:</strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>Hoher Zeitaufwand für Inserate und Anfragen</li>
                    <li>Unsichere Preisverhandlungen</li>
                    <li>Risiko von Betrug oder Zahlungsausfällen</li>
                    <li>Haftungspflichten und rechtliche Unsicherheiten</li>
                  </ul>

                  <p>
                    <strong>Händlernetzwerk über Autoeinfachlos:</strong>
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>5.000 geprüfte Händler aus ganz Österreich</li>
                    <li>24-Stunden-Auktion für den besten Marktpreis</li>
                    <li>Kein Papierkram, keine versteckten Gebühren</li>
                    <li>Garantierte Zahlung und kostenlose Abholung</li>
                  </ul>

                  <p>
                    Unser System sorgt dafür, dass du den besten verfügbaren
                    Preis bekommst – nicht von einem einzelnen Käufer, sondern
                    durch den Wettbewerb vieler Händler.
                  </p>
                  <p>
                    So kombinierst du schnellen Verkauf, sicheren Ablauf und
                    faire Konditionen.
                  </p>

                  <h3>Ablauf beim Notverkauf mit Autoeinfachlos</h3>
                  <p>
                    Der gesamte Verkaufsprozess ist so gestaltet, dass du keine
                    Zeit verlierst und gleichzeitig volle Kontrolle behältst.
                  </p>

                  <p>
                    <strong>So funktioniert’s:</strong>
                  </p>
                  <ol className="custom-ordered-list secondary">
                    <li>
                      <strong>Fahrzeug kostenlos online bewerten:</strong> Trage
                      Marke, Modell und Laufleistung ein. Unser System zeigt dir
                      sofort den geschätzten Wert.
                    </li>
                    <li>
                      <strong>
                        Angebote in der 24-Stunden-Auktion erhalten:
                      </strong>{" "}
                      Dein Fahrzeug wird automatisch in unser Händlernetzwerk
                      eingespeist. Innerhalb eines Tages liegen dir verbindliche
                      Angebote vor.
                    </li>
                    <li>
                      <strong>Bestes Angebot auswählen:</strong> Du
                      entscheidest, ob der Preis für dich passt - ohne Druck und
                      ohne Verpflichtung.
                    </li>
                    <li>
                      <strong>Abholung & Auszahlung:</strong> Der Käufer holt
                      dein Auto bei dir ab, du erhältst den vereinbarten Betrag
                      sicher.
                    </li>
                  </ol>

                  <p>
                    Damit wird aus dem Notverkauf deines privaten Autos ein
                    reibungsloser und sicherer Prozess, bei dem du weder
                    Inserate noch Probefahrten oder Papierkram erledigen musst.{" "}
                    <Link className="link" href="/auto-bewerten">
                      Jetzt kostenlos Auto bewerten
                    </Link>
                  </p>
                </>
              }
            />
            <div className="Banner-sections">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                isBig
                title="Was ist mein Auto beim Notverkauf noch wert?"
                alt="Fahrzeugbewertung beim Notverkauf"
                text={
                  <>
                    <p>
                      Viele glauben, dass man beim Notverkauf automatisch große
                      finanzielle Einbußen hinnehmen muss.
                    </p>
                    <p>
                      Das stimmt so nicht – wenn du die richtige
                      Verkaufsstrategie wählst.
                    </p>

                    <p>Der Wert deines Autos hängt von mehreren Faktoren ab:</p>
                    <ul className="custom-unordered-list">
                      <li>Fahrzeugzustand (Karosserie, Innenraum, Technik)</li>
                      <li>Laufleistung und Wartungshistorie</li>
                      <li>Marke, Modell und Baujahr</li>
                      <li>Nachfrage auf dem Gebrauchtwagenmarkt</li>
                    </ul>

                    <p>
                      Über unser Händlernetzwerk wird dein Auto objektiv
                      bewertet und fair gehandelt – selbst wenn es Mängel hat
                      oder nicht mehr fahrbereit ist.
                    </p>
                    <p>
                      Weil mehrere Händler gleichzeitig bieten, entsteht ein
                      fairer Marktpreis, auch
                      wenn du schnell verkaufen musst.
                    </p>
                    <p>
                      Nutze am besten gleich unsere kostenlose Online-Bewertung,
                      um deinen Fahrzeugwert in wenigen Minuten zu erfahren:
                    </p>
                    <p>
                      👉{" "}
                      <Link className="link" href="/auto-bewerten">
                        Auto bewerten
                      </Link>
                    </p>
                  </>
                }
              />

              <BildTextInfo
                image={vonZuhauseAus}
                revert
                isBig
                h2
                fontSize="36px"
                alt="Rechtssicherer Notverkauf mit Autoeinfachlos"
                title="Rechtliche Sicherheit beim privaten Notverkauf"
                text={
                  <>
                    <p>
                      Beim privaten Autoankauf lauern viele rechtliche
                      Fallstricke: Ein Käufer meldet sich plötzlich nicht mehr,
                      möchte nachträglich den Preis drücken oder reklamiert
                      Mängel, obwohl alles besprochen war.
                    </p>
                    <p>
                      In solchen Fällen drohen Rückabwicklungen, Streitigkeiten
                      oder rechtliche Konsequenzen.
                    </p>

                    <p>Mit Autoeinfachlos bist du auf der sicheren Seite:</p>
                    <ul className="custom-unordered-list">
                      <li>Verkauf nur an geprüfte Händler</li>
                      <li>rechtssichere Kaufverträge</li>
                      <li>
                        sofortige Zahlung - kein Risiko von geplatzten
                        Überweisungen
                      </li>
                      <li>keine Haftung nach dem Verkauf</li>
                    </ul>

                    <p>
                      Damit kannst du dein Fahrzeug schnell und rechtssicher
                      abgeben, ohne dich um Formalitäten zu kümmern.
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufige Fragen rund um den Notverkauf Auto Privat"
              fragen={fragenNotverkauf}
              image={FAQImage}
              removePaddingBottom
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Notverkauf Auto Privat"
                autoVerkaufen
                autoBewerten
                wasistmeinautowert
                listenpreisBerechnen
                kaputtesAuto
                autoVerkaufenTirol
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={sellCarCash}
                h2
                isBig
                fontSize="36px"
                title="Dein Notverkauf - einfach, sicher und fair"
                alt="Notverkauf Auto einfach und fair"
                text={
                  <>
                    <p>
                      Ein Notverkauf ist nie angenehm - aber er kann
                      unkompliziert und stressfrei sein.
                    </p>
                    <p>
                      Mit Autoeinfachlos hast du einen seriösen Partner, der
                      den gesamten Prozess abnimmt: von der Bewertung über die
                      Händlerauktion bis zur sicheren Auszahlung.
                    </p>
                    <p>
                      Jetzt kostenlos Fahrzeugwert ermitteln und in 24 Stunden
                      verkaufen - sicher, fair und ohne Risiko:{" "}
                      <Link className="link" href="/auto-bewerten">
                        Jetzt Auto bewerten
                      </Link>
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-bewerten"
            title="Jetzt kostenlos Fahrzeugwert ermitteln und in 24 Stunden verkaufen"
            h3
          />
        </div>
      )}
    </div>
  );
}

export default AutoNotVerkauf;
